<template>
  <AppBanner>
    Edit Province
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader
      :is-loading="loading"
      text="Loading province..."
    />
  </template>

  <template v-else-if="!province">
    <h1 class="mt-5 flex items-center justify-center h-full">
      Unable to load province. Please try again.
    </h1>
  </template>

  <template v-else>
    <ProvinceForm :model="province" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { ProvinceForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const province = ref(null);

onMounted(async () => {
  await loadProvince();
});

const loadProvince = async () => {
  const response = await useHttp().get(`/provinces/${route.params.province}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    province.value = response.data;
  }

  loading.value = false;
};

</script>
